{
    "Accessibility menu": "Menu prístupnosti",
    "Close": "Zavrieť",
    "Content adjustments": "Úpravy obsahu",
    "Navigation adjustments": "Úpravy navigácie",
    "Text Align": "Zarovnanie textu",
    "Align Left": "Zarovnať doľava",
    "Align Center": "Zarovnať na stred",
    "Align Right": "Zarovnať vpravo",
    "Adjust Font Size": "Upraviť veľkosť písma",
    "Highlight Title": "Zvýrazniť nadpis",
    "Highlight Links": "Zvýrazniť odkazy",
    "Readable Font": "Čitateľné písmo",
    "Colour adjustments": "Úpravy farieb",
    "Dark Contrast": "Tmavý kontrast",
    "Light Contrast": "Svetlý kontrast",
    "High Contrast": "Vysoký kontrast",
    "High Saturation": "Vysoká sýtosť",
    "Low Saturation": "Nízka sýtosť",
    "Monochrome": "Monochróm",
    "Tools": "Nástroje",
    "Reading Guide": "Sprievodca čítaním",
    "Big Cursor": "Veľký kurzor",
    "Increase Font Size": "Zväčšiť písmo",
    "Decrease Font Size": "Zmenšiť písmo",
    "Letter Spacing": "Medzera medzi písmenami",
    "Line Height": "Výška riadku",
    "Font Weight": "Hrúbka písma",
    "Dyslexia Font": "Písmo pre dyslexiu",
    "Language": "Jazyk",
    "Accessibility widget": "Otvoriť menu prístupnosti",
    "Accessibility Profiles": "Profily prístupnosti",
    "Cognitive Disability": "Kognitívne postihnutie",
    "Seizure Safe": "Bezpečné pri záchvatoch",
    "Accessibility statement": "Vyhlásenie o prístupnosti",
    "ADHD": "ADHD",
    "Low Vision": "Slabý zrak",
    "Pause Animations": "Zastaviť animácie",
    "Animation paused": "Animácia pozastavená",
    "Reset all settings": "Obnoviť nastavenia",
    "Shortcut:": "Skratka:",
    "Epilepsy Safe Mode": "Režim bezpečný pri epilepsii",
    "Mute sounds": "Stlmiť zvuky",
    "Page read": "Čítať stránku",
    "Page read controls": "Ovládanie čítania stránky",
    "Pause": "Pozastaviť",
    "Resume": "Pokračovať",
    "Stop": "Zastaviť",
    "Settings": "Nastavenia",
    "Speed": "Rýchlosť",
    "Voice": "Hlas",
    "Close accessibility menu": "Zavrieť ponuku prístupnosti",
    "Back to accessibility menu": "Späť do ponuky prístupnosti",
    "Search languages": "Hľadať jazyky",
    "Selected language": "Vybraný jazyk",
    "View accessibility statement (opens in new window)": "Zobraziť vyhlásenie o prístupnosti (otvorí sa v novom okne)",
    "Visit CookieYes website (opens in new window)": "Navštíviť webovú stránku CookieYes (otvorí sa v novom okne)",
    "Reset all accessibility settings to default": "Obnoviť všetky nastavenia prístupnosti na predvolené"
}
